<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx default-input md:flex">
              <vs-input
                class="inputx mr-2"
                placeholder="Placeholder"
                v-model="value11"
              />
              <vs-input
                disabled
                class="inputx"
                placeholder="Disabled"
                v-model="value22"
              />
            </div>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Label</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx labelx md:flex">
              <vs-input
                label="Name"
                placeholder="Placeholder"
                class="mr-2"
                v-model="value11"
              />
              <vs-input
                type="password"
                label="Password"
                placeholder="Password"
                v-model="value22"
              />
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Label Placeholder</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx labelx md:flex">
              <vs-input
                class="mr-2"
                label-placeholder="Label-placeholder"
                v-model="value11"
              />
              <vs-input
                disabled="true"
                label-placeholder="Label-placeholder-disabled"
                v-model="value22"
              />
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Colors</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx labelx md:flex">
              <vs-input
                label-placeholder="Default"
                class="mr-2"
                v-model="value11"
              />
              <vs-input
                color="success"
                label-placeholder="Success"
                class="mr-2"
                v-model="value22"
              />
              <vs-input
                color="danger"
                label-placeholder="Danger"
                class="mr-2"
                v-model="value3"
              />
              <vs-input
                color="warning"
                label-placeholder="Warning"
                class="mr-2"
                v-model="value4"
              />
              <vs-input
                color="dark"
                label-placeholder="Dark"
                class="mr-2"
                v-model="value5"
              />
              <vs-input
                color="rgb(213, 14, 151)"
                label-placeholder="RGB: rgb(213, 14, 151)"
                class="mr-2"
                v-model="value6"
              />
              <vs-input
                color="#11e988"
                label-placeholder="HEX: #11e988"
                class="mr-2"
                v-model="value7"
              />
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Validations</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx labelx md:flex">
              <vs-input
                :success="true"
                success-text="The mail is valid"
                placeholder="Email Success"
                v-model="value11"
                class="mr-2"
              />
              <vs-input
                :danger="true"
                danger-text="The password does not meet the standards"
                placeholder="Password Danger"
                v-model="value22"
                class="mr-2"
              />
              <vs-input
                :warning="true"
                warning-text="The entered data could not be verified"
                placeholder="Date Warning"
                v-model="value3"
                class="mr-2"
              />
              <vs-input
                description-text="Just enter the first two numbers of your phone"
                placeholder="Phone Description"
                v-model="value4"
              />
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Size</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centerx labelx md:flex">
              <vs-input
                size="large"
                placeholder="Size large"
                class="mr-2"
                v-model="value11"
              />
              <vs-input
                size="default"
                placeholder="Size default"
                class="mr-2"
                v-model="value22"
              />
              <vs-input
                size="small"
                placeholder="Size small"
                class="mr-2"
                v-model="value3"
              />
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      value11: "",
      value22: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
    };
  },
};
</script>